import { useState } from 'react'
import clsx from 'clsx'
import {
  Button,
  Card,
  CardProps,
  Modal,
  Paragraph,
  Title,
} from 'components/common'
import {
  BookingDisapprovalModal,
  BookingDisapprovalModalProps,
} from 'components/bookings'
import { OrderApproval } from 'lib/graphql/storeadmin'

export interface ApprovalStatusCardProps
  extends Omit<BookingDisapprovalModalProps, 'onClose'>,
    CardProps {
  loading?: boolean
  disabled?: boolean
  approval: OrderApproval
  approvalRequired: boolean
  onApprove: () => void
}

export const RenderCancelMessage = (message: string) => (
  <div className={clsx('rounded-lg', 'bg-gray-100', 'p-8')}>
    <div className={clsx('flex', 'flex-col', 'flex-center', 'items-center')}>
      <Paragraph>{message}</Paragraph>
    </div>
  </div>
)

export const ApprovalStatusCard = ({
  loading,
  disabled,
  approval,
  approvalRequired,
  onApprove,
  onDisapprove,
}: ApprovalStatusCardProps) => {
  const [isModal, setIsModal] = useState<boolean>(false)
  const [isDialog, setIsDialog] = useState<boolean>(false)

  const renderButtons = (): JSX.Element => {
    switch (approval) {
      case OrderApproval.Approved:
        return (
          <Button type="primary" disabled style={{ width: '100%' }}>
            承認済
          </Button>
        )

      case OrderApproval.Disapproved:
        return (
          <Button danger disabled style={{ width: '100%' }}>
            非承認済み
          </Button>
        )

      default:
        return (
          <div className="flex items-center justify-between space-x-4">
            {/* 承認不要もしくは非承認済みの場合は非活性 */}
            <Button
              type="primary"
              onClick={() => setIsDialog(true)}
              style={{ width: '100%' }}
            >
              承認する
            </Button>
            <Button
              danger
              onClick={() => setIsModal(true)}
              style={{ width: '100%' }}
            >
              非承認する
            </Button>
          </div>
        )
    }
  }

  return (
    <>
      <Card shadow loading={loading}>
        <Title level={5}>承認</Title>

        {disabled
          ? RenderCancelMessage(
              'キャンセルされた予約のため、承認ステータスを変更することはできません。'
            )
          : renderButtons()}
      </Card>

      <Modal
        title={'予約を承認する'}
        visible={isDialog}
        onCancel={() => setIsDialog(false)}
        onOk={() => {
          onApprove()
          setIsDialog(false)
        }}
        okText={'実行'}
        cancelText={'閉じる'}
      >
        <div>予約を承認します</div>
      </Modal>
      <BookingDisapprovalModal
        visible={isModal}
        onClose={setIsModal}
        onDisapprove={onDisapprove}
      />
    </>
  )
}
